import {
  GetProductOrderHistoryWithManagerResponseDTO,
  GetProductsOverviewResponseDTO,
  GetRemainingProductsResponseDTO,
  GetRevenuesResponseDTO,
} from "@/api/types/main/schemas";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type CategoriesWithProducts =
  | GetProductOrderHistoryWithManagerResponseDTO[]
  | GetProductsOverviewResponseDTO[]
  | GetRevenuesResponseDTO[]
  | GetRemainingProductsResponseDTO[];

export const applyFavoritesUpdate = (
  data: CategoriesWithProducts,
  productId: number,
  isFavorite: boolean
) => {
  const snapshot = data.map((cat) => ({
    category: cat.category,
    products: cat.products.map((p) => ({ ...p })),
  }));

  if (isFavorite) {
    let favoriteProduct;
    const withoutProduct = snapshot
      .map((cat) => {
        const idx = cat.products.findIndex((p) => p.id === productId);
        if (idx !== -1) {
          favoriteProduct = { ...cat.products[idx], isFavorite: true };
          const newProducts = [...cat.products.slice(0, idx), ...cat.products.slice(idx + 1)].sort(
            (a, b) => a.name.localeCompare(b.name)
          );
          return { category: cat.category, products: newProducts };
        }
        return { category: cat.category, products: cat.products };
      })
      .filter((cat) => cat.products.length > 0);

    const favIdx = withoutProduct.findIndex((cat) => cat.category === "Избранное");
    let updatedCategories: CategoriesWithProducts;
    if (favIdx !== -1) {
      const favCat = withoutProduct[favIdx];
      const newFavProducts = [...favCat.products, favoriteProduct!].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      updatedCategories = [
        ...withoutProduct.slice(0, favIdx),
        { category: "Избранное", products: newFavProducts },
        ...withoutProduct.slice(favIdx + 1),
      ];
    } else {
      updatedCategories = [
        { category: "Избранное", products: [favoriteProduct!] },
        ...withoutProduct,
      ];
    }

    const [favCategory, ...rest] = updatedCategories;
    rest.sort((a, b) => a.category.localeCompare(b.category));
    return [favCategory, ...rest];
  } else {
    const favoriteCategory = snapshot.find((cat) => cat.category === "Избранное");
    if (!favoriteCategory) {
      return snapshot;
    }
    const favIdx = favoriteCategory.products.findIndex((p) => p.id === productId);
    if (favIdx === -1) {
      return snapshot;
    }
    const [removedProduct] = favoriteCategory.products.splice(favIdx, 1);
    const baseProduct = { ...removedProduct, isFavorite: false };

    const mainIdx = snapshot.findIndex((cat) => cat.category === removedProduct.category);
    if (mainIdx === -1) {
      snapshot.push({ category: removedProduct.category, products: [baseProduct] });
    } else {
      const mainCat = snapshot[mainIdx];
      mainCat.products = [...mainCat.products, baseProduct].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      snapshot[mainIdx] = { category: mainCat.category, products: mainCat.products };
    }

    const [fav, ...rest] = snapshot;
    rest.sort((a, b) => a.category.localeCompare(b.category));
    return [fav, ...rest];
  }
};
